// TODO: I'm using the production API for now because it's easier and YOLO.
export const API_URL = "https://stupendousman.magicseven.ai";
// export const API_URL =
//   process.env.NODE_ENV !== "production"
//     ? "http://localhost:5500/"
//     : "https://stupendousman.magicseven.ai/";

// export const SOCKET_URL =
//   process.env.NODE_ENV !== "production"
//     ? "http://localhost:5500"
//     : "https://stupendousman.magicseven.ai";

export const SOCKET_URL = "https://stupendousman.magicseven.ai";
